import React from 'react';
import { useState } from 'react';
import styled from 'styled-components'
import { Box } from './ventblock';

export default function ControlBlock() {

  const [count, setCount] = useState(55);
  const [countTwo, setCountTwo] = useState(12);
  const [countThree, setCountThree] = useState(145);

  const _minus = e => {
    e.preventDefault();
    e.stopPropagation();
    setCount(count - 1);
  }

  const _plus = e => {
    e.preventDefault();
    e.stopPropagation();
    setCount(count + 1);
  }

  const _minusTwo = e => {
    e.preventDefault();
    e.stopPropagation();
    setCountTwo(countTwo - 1);
  }

  const _plusTwo = e => {
    e.preventDefault();
    e.stopPropagation();
    setCountTwo(countTwo + 1);
  }

  const _minusThree = e => {
    e.preventDefault();
    e.stopPropagation();
    setCountThree(countThree - 1);
  }

  const _plusThree = e => {
    e.preventDefault();
    e.stopPropagation();
    setCountThree(countThree + 1);
  }

  return (<>
    <Box>
      <Grid>
        <div>
          <Label>Oxygen</Label>
          <BRow>
            <CButton onClick={_minus}>-</CButton>
            <Center>{count}</Center>
            <CButton onClick={_plus}>+</CButton>
          </BRow>
          <BottomLabel>%</BottomLabel>
        </div>
        <div>
          <Label>PEEP/CPAP</Label>
          <BRow>
            <CButton onClick={_minusTwo}>-</CButton>
            <Center>{countTwo}</Center>
            <CButton onClick={_plusTwo}>+</CButton>
          </BRow>
          <BottomLabel>cmH20</BottomLabel>
        </div>
        <div>
          <Label>PEEP/CPAP</Label>
          <BRow>
            <CButton onClick={_minusThree}>-</CButton>
            <Center>{countThree}</Center>
            <CButton onClick={_plusThree}>+</CButton>
          </BRow>
          <BottomLabel>%</BottomLabel>
        </div>
      </Grid>
    </Box>
  </>)
};
const BottomLabel = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: center;
  color: rgba(255,255,255,0.5);
  font-size: 14px;
  @media screen and (max-width: 823px) and (orientation: landscape) {
      font-size: 12px;
    }
`;
const Center = styled.div`
  font-size: 35px;
  font-weight: 600;
  @media screen and (max-width: 823px) and (orientation: landscape) {
      font-size: 22px;
    }
`;

export const Button = styled.button`
cursor: pointer;
  background-color: #1f8efa;
  outline: none;
  border: none;
  display: flex;
  border-radius: 10px;
  justify-content: center;
  align-items: center;
  color: white;
`;

const CButton = styled(Button)`
  height: 40px;
  width: 40px;
    font-size: 20px;
    @media screen and (max-width: 823px) and (orientation: landscape) {
      height: 30px;
      width: 30px;
      font-size: 14px;
    }
`;
const Grid = styled.div`
  display: grid;
  grid-template-rows: 1fr 1fr 1fr;
  height: 100%;
  @media screen and (max-width: 823px) and (orientation: landscape) {
      overflow: hidden;
      font-size: 13px;
    }
`;

const Label = styled.div`
margin-bottom: 20px;
@media screen and (max-width: 823px) and (orientation: landscape) {
     margin-bottom: 10px;
    }
`;

const BRow = styled.div` 
color: #1f8efa;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
`;
